<template>
  <div>
    <list
      ref="list"
      unit="销售单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @row-select="x=>$emit('change', x)"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="调拨类型">
          <el-select size="mini" v-model="params.AllotType" placeholder="请选择" clearable>
            <el-option label="同价调拨" :value="0"></el-option>
            <el-option label="异价调拨" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsNames" placeholder="请输入商品名称" />
        </el-form-item> -->
        <el-form-item label="调入仓库">
          <el-select
            size="mini"
            v-model="params.InWarehouseId"
            placeholder="请选择"
          >
            <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调出仓库">
          <el-select
            size="mini"
            v-model="params.OutWarehouseId"
            placeholder="请选择"
          >
          <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="110px" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px" />
        <el-table-column prop="AllotType" label="调拨类型">
          <template slot-scope="{row}">
            <span v-if="row.AllotType==0">同价调拨</span>
            <span v-else>异价调拨</span>
          </template>
        </el-table-column>
        <el-table-column prop="InWarehouseName" label="调入仓库" />
        <el-table-column prop="OutWarehouseName" label="调出仓库" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/stock/allotDoc").default,
      wareApi: require("@/api/ba/warehouse").default,
      wareList: [],
      params: {
        DocNo: "",
        DocDate: "",
        AllotType: 0,
        OutWarehouseId: null,
        OutWarehouseName: "",
        InWarehouseId: null,
        InWarehouseName: "",
        Status: null,
        GoodsNames: "",
        DocDateStart:this.$commonJs.getDayOffset(-30),
        DocDateEnd:this.$commonJs.getDayOffset(0)
      },
    };
  },
  mounted() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
};
</script>